<template>
    <v-app>
        <v-main class="main-bg">

            <!-- HERO / BANNER -->
            <section class="fill-height bg-4 d-flex align-center">
                <v-container>
                    <div class="d-flex justify-center position-relative logo-circle">
                        <img src="@/assets/passport-banner/live-album-logo-circle.png" height="120" alt="">
                    </div>
                    <div class="d-flex justify-center mt-neg-40 position-relative">
                        <div class="border-gold border-radius-15 pa-10 bg-white w-100 max-w-800">
                            <div class="text-center">
                                <v-icon color="success" size="72" class="mb-2">mdi-check-circle</v-icon>
                                <h2 class="text-blue font-facifico">Thank You for Registering!</h2>
                                <div class="text-gold mt-1">{{ details.user?.name }}</div>
                            </div>

                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-4 text-center">
                                Your registration was successful.
                            </div>

                            <div class="text-box border-blue border-radius-10 text-blue pa-2 mt-2 text-center">
                                <v-icon>mdi-email-outline</v-icon>
                                Please check your email
                                <span v-if="details.user?.email"> ({{ details.user?.email }}) </span>
                                for more details about your event.
                            </div>

                            <div class="text-caption text-center text-blue mt-3">
                                Didn't get it? Check your spam or junk folder.
                            </div>

                            <v-btn large block class="mt-6 darken-4" color="primary" @click="resendEmail">
                                <v-icon left>mdi-home</v-icon>
                                Back to Home
                            </v-btn>
                        </div>
                    </div>
                </v-container>
            </section>

            <v-snackbar v-model="snackbar" timeout="3000" color="success" bottom>
                Confirmation email resent!
            </v-snackbar>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: "RegistrationThankYou",

    data() {
        return {
            snackbar: false,
            details: {
                user: {
                    name: this.$route?.query?.name || "",
                    email: this.$route?.query?.email || "",
                    mobile: this.$route?.query?.mobile || "",
                    city: this.$route?.query?.city || "",
                },
            },
        };
    },

    methods: {
        goHome() {
            this.$router.push({ path: "/" });
        },

        resendEmail() {
            // TODO: hook this up to your actual resend-confirmation API call
            this.snackbar = true;
        },
    },
};
</script>